import { useMemo, useRef, useState } from 'react'
import ReportsPagesContent from 'src/component/ReportsPagesContent'
import { Original } from 'src/common/Common.Type'
import BaseBtn from 'src/component/ActionBtn/BaseBtn'

import { SearchPatient } from 'src/requests/Shared'
import MedicalFilesPopup from './Popup/MedicalFilesPopup'

const MedicalFiles = () => {

  const [rowId, setRowId] = useState<number | null>(null)

  const imgsRef = useRef<any>(null)


  const columns = useMemo(() => [
    {
      Header: "patientName",
      accessor: "patientName"
    },
    {
      Header: "patientNationalId",
      accessor: "patientNationalId"
    },
    {
      Header: "action",
      Cell: ({ row: { original } }: Original) => (
        <>
          <BaseBtn icon={"material-symbols:edit-sharp"} className='update' ApplyAction={() => handleUpdateModal(original?.id)} isDisabled={false} />
        </>
      )
    }
  ], [])

  const handleUpdateModal = (patientId: number) => {
    imgsRef.current.click()
    setRowId(patientId)
  }

  return (
    <>
      <MedicalFilesPopup modalId={imgsRef} patientId={rowId} />
      <ReportsPagesContent needParams columns={columns} tableAPI={SearchPatient} />
    </>
  )
}

export default MedicalFiles